export function getApiUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window === 'undefined') {
    return 'http://54.165.139.51:9720';
  }

  return `${window.location.protocol}//${window.location.hostname}:8000`;
}

export const API_URL = getApiUrl();
